/* eslint-disable react-refresh/only-export-components -- co-locating Provider + hook for the annex-link context is intentional and matches names-context */
import { createContext, useContext, type ReactNode } from 'react';

type AnnexLinkContextValue = {
  isAnnexPage: boolean;
  parentDefinitionSlug: string | null;
};

const AnnexLinkContext = createContext<AnnexLinkContextValue>({
  isAnnexPage: false,
  parentDefinitionSlug: null,
});

function AnnexLinkProvider({
  children,
  parentDefinitionSlug = null,
}: {
  children: ReactNode;
  parentDefinitionSlug?: string | null;
}) {
  return (
    <AnnexLinkContext.Provider
      value={{ isAnnexPage: true, parentDefinitionSlug }}
    >
      {children}
    </AnnexLinkContext.Provider>
  );
}

function useAnnexLink(): boolean {
  return useContext(AnnexLinkContext).isAnnexPage;
}

function useAnnexParentDefinitionSlug(): string | null {
  return useContext(AnnexLinkContext).parentDefinitionSlug;
}

export { AnnexLinkProvider, useAnnexLink, useAnnexParentDefinitionSlug };
